<template>
  <b-container fluid>
    <form>
      <!-- Hasta Bilgileri -->
      <b-row class="mb-3">
        <b-col md="4">
          <b-form-group :label="$t('NameAndSurname')">
            <b-form-input v-model="customer.name" disabled />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('ClinicNumber')">
            <b-form-input v-model="customer.clinicNumber" disabled />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('DateOfBirth')">
            <b-form-input v-model="customer.dateOfBirth" disabled />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('Gender')">
            <b-form-input v-model="customer.gender" disabled />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('NationalNumber')">
            <b-form-input v-model="customer.nationalNumber" disabled />
          </b-form-group>
        </b-col>
      </b-row>

      <hr />

      <!-- Doktor ve Reçete Bilgileri -->
      <b-row class="mb-3">
        <b-col md="4">
          <b-form-group :label="$t('Consultant') + ' / ' + $t('Doctor')">
            <v-select v-model="model.staffID"
                      :reduce="s => s.id"
                      label="name"
                      :options="staffList"
                      @input="validateForVSelect" />
            <span class="text-danger small" v-text="validationErrors.StaffID" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group :label="$t('Weight')">
            <b-form-input v-model="model.weight" @keypress="$root.isNumber" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <template #label>
              {{ $t('ProtocolNo') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.protocolNo">&#9432;</span>
            </template>
            <b-form-input v-model="model.protocolNo" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <template #label>
              {{ $t('TrackingNo') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.trackingNo">&#9432;</span>
            </template>
            <b-form-input v-model="model.trackingNo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col md="2">
          <b-form-group>
            <template #label>
              {{ $t('PrescriptionTypes') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.prescriptionType">&#9432;</span>
            </template>
            <v-select v-model="model.prescriptionType"
                      :reduce="s => s.id"
                      label="name"
                      :clearable="false"
                      :options="prescriptionTypes" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <template #label>
              {{ $t('Diagnoses') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.diagnoses">&#9432;</span>
            </template>
            <v-select v-model="selectedIcdCodes"
                      :options="icdList"
                      :reduce="s => s.id"
                      label="name"
                      multiple
                      :filterable="false"
                      @search="fetchIcdCodes"
                      :placeholder="$t('StartTypingToFilter')" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <template #label>
              {{ $t('InsuranceType') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.insuranceType">&#9432;</span>
            </template>
            <v-select v-model="model.insuranceType"
                      :reduce="s => s.id"
                      label="name"
                      :options="insuranceTypeList" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <template #label>
              {{ $t('ProvisionType') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.provisionType">&#9432;</span>
            </template>
            <v-select v-model="model.provisionType"
                      :reduce="s => s.id"
                      label="name"
                      :options="provisionTypeList" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <template #label>
              {{ $t('PrescriptionSubType') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.prescriptionSubType">&#9432;</span>
            </template>
            <v-select v-model="model.prescriptionSubType"
                      :reduce="s => s.id"
                      label="name"
                      :options="prescriptionSubTypeList" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col md="12">
          <b-form-group :label="$t('DrugAllergiesNone')">
            <b-form-textarea v-model="model.drug_Allergies_None" rows="2" />
          </b-form-group>
        </b-col>
      </b-row>

      <hr />

      <!-- İlaç / Tıbbi Cihaz Satırları -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">{{ $t('PrescriptionDrugs') }}</h5>
        <b-button variant="success" size="sm" @click="addDetailRow">
          <i class="fa fa-plus mr-1"></i> {{ $t('AddNewLine') }}
        </b-button>
      </div>

      <div v-for="(detail, index) in model.prescriptionDetails" :key="index" class="drug-row border rounded p-3 mb-3">
        <!-- Satır 1: İlaç seçimi + Miktar -->
        <b-row class="mb-2">
          <template v-if="model.prescriptionType != 3">
            <b-col md="2">
              <b-form-group label-size="sm" class="mb-0">
                <template #label>
                  {{ $t('NonDrugsProduct') }}
                  <span class="info-tip" v-b-tooltip.hover="tooltips.nonDrugsProduct">&#9432;</span>
                </template>
                <v-select v-model="detail.nonDrugsProduct"
                          :reduce="s => s.id"
                          label="name"
                          :options="yesNoList"
                          :clearable="false" />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-form-group :label="$t('Drug')" label-size="sm" class="mb-0">
                <b-form-input v-if="detail.nonDrugsProduct"
                              v-model="detail.drug"
                              size="sm" />
                <v-select v-else
                          v-model="detail.skrsDrugId"
                          :options="drugList"
                          @search="fetchDrugs"
                          :reduce="s => s.id"
                          label="name"
                          :filterable="false"
                          :placeholder="$t('SeekDrug')" />
              </b-form-group>
            </b-col>
          </template>
          <template v-else>
            <b-col md="7">
              <b-form-group label-size="sm" class="mb-0">
                <template #label>
                  {{ $t('MedicalDevice') }}
                  <span class="info-tip" v-b-tooltip.hover="tooltips.medicalDevice">&#9432;</span>
                </template>
                <v-select v-model="detail.skrsSutId"
                          :reduce="s => s.id"
                          label="name"
                          :options="sutList"
                          @search="fetchSuts"
                          :placeholder="$t('SeekDevice')" />
              </b-form-group>
            </b-col>
          </template>
          <b-col md="2">
            <b-form-group label-size="sm" class="mb-0">
              <template #label>
                {{ model.prescriptionType != 3 ? $t('Box') : $t('Count') }}
                <span class="info-tip" v-b-tooltip.hover="model.prescriptionType != 3 ? tooltips.box : tooltips.count">&#9432;</span>
              </template>
              <b-form-input v-model="detail.quantity" size="sm" @keypress="$root.isNumber" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label-size="sm" class="mb-0">
              <template #label>
                {{ $t('PeriodDrug') }}
                <span class="info-tip" v-b-tooltip.hover="tooltips.period">&#9432;</span>
              </template>
              <v-select v-model="detail.period"
                        :reduce="s => s.id"
                        label="name"
                        :options="periodList" />
            </b-form-group>
          </b-col>
          <b-col md="1" class="d-flex align-items-end justify-content-center pb-1">
            <b-button v-if="index != 0" variant="outline-danger" size="sm" @click="removeDetailRow(detail)">
              <i class="fas fa-times"></i>
            </b-button>
          </b-col>
        </b-row>
        <!-- Satır 2: Dozaj + Kullanım -->
        <b-row>
          <template v-if="model.prescriptionType != 3">
            <b-col md="2">
              <b-form-group label-size="sm" class="mb-0">
                <template #label>
                  {{ $t('DrugsDose1') }}
                  <span class="info-tip" v-b-tooltip.hover="tooltips.dose1">&#9432;</span>
                </template>
                <b-form-input v-model="detail.dose1" size="sm" @keypress="$root.isNumber" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label-size="sm" class="mb-0">
                <template #label>
                  {{ $t('DrugsDose2') }}
                  <span class="info-tip" v-b-tooltip.hover="tooltips.dose2">&#9432;</span>
                </template>
                <b-form-input v-model="detail.dose2" size="sm" @keypress="$root.isNumber" />
              </b-form-group>
            </b-col>
          </template>
          <b-col md="3">
            <b-form-group label-size="sm" class="mb-0">
              <template #label>
                {{ $t('DrugUsageMethod') }}
                <span class="info-tip" v-b-tooltip.hover="tooltips.drugUsageMethod">&#9432;</span>
              </template>
              <v-select v-if="model.prescriptionType == 3"
                        v-model="detail.sutUsageMethod"
                        :reduce="s => s.id"
                        label="name"
                        :options="sutUsageMethods" />
              <v-select v-else
                        v-model="detail.drugUsageMethod"
                        :reduce="s => s.id"
                        label="name"
                        :options="drugUsageMethods" />
            </b-form-group>
          </b-col>
          <b-col v-if="model.prescriptionType == 3" md="3">
            <b-form-group label-size="sm" class="mb-0">
              <template #label>
                {{ $t('MedicalDeviceUsageLocation') }}
                <span class="info-tip" v-b-tooltip.hover="tooltips.medicalDeviceUsageLocation">&#9432;</span>
              </template>
              <v-select v-model="detail.sutUsageLocation"
                        :reduce="s => s.id"
                        label="name"
                        :options="medicalDeviceUsageLocationList" />
            </b-form-group>
          </b-col>
          <b-col :md="model.prescriptionType != 3 ? 5 : 6">
            <b-form-group :label="$t('Explanation')" label-size="sm" class="mb-0">
              <b-form-input v-model="detail.explanation" size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <hr />

      <!-- Doktor Notu -->
      <b-row class="mb-3">
        <b-col md="12">
          <b-form-group>
            <template #label>
              {{ $t('Comments') }}
              <span class="info-tip" v-b-tooltip.hover="tooltips.comments">&#9432;</span>
            </template>
            <b-form-textarea v-model="model.comments" maxlength="1000" />
          </b-form-group>
        </b-col>
      </b-row>

      <modal-footer-button :set-is-submitting="isSubmitting"
                           @submit="submitPrescription()" />
    </form>
  </b-container>
</template>

<script>
  import prescriptionService from '../../../services/prescription'
  import customerDiagnoseService from '../../../services/customerDiagnose'
  import ModalFooterButton from '../../../components/shared/ModalFooterButton'

  export default {
    name: 'NewPrescription',
    components: {
      ModalFooterButton
    },
    props: {
      customerId: String,
      appointmentId: String,
      sysTakipNo: String,
      staffId: String,
      prescriptionCode: String,
      hospitalReferenceNo: String
    },
    data() {
      return {
        isSubmitting: false,
        customer: {
          name: '',
          gender: '',
          dateOfBirth: '',
          clinicNumber: '',
          nationalNumber: ''
        },
        model: {
          id: '',
          customerID: '',
          staffID: '',
          weight: '',
          drug_Allergies_None: '',
          drName: '',
          date: '',
          comments: '',
          prescriptionDetails: [],
          protocolNo: '',
          trackingNo: '',
          icdCodes: [],
          prescriptionType: 1,
          insuranceType: '',
          provisionType: '',
          prescriptionSubType: '',
          showNationalNumberOnPdf: true,
          showDateOfBirthOnPdf: true,
          showGenderOnPdf: true,
          sysTakipNo: '',
          hospitalReferenceNo: ''
        },
        validationErrors: {
          StaffID: ''
        },
        icdList: [],
        selectedIcdCodes: [],
        staffList: [],
        drugList: [],
        sutList: [],
        prescriptionTypes: [],
        periodList: [],
        drugUsageMethods: [],
        sutUsageMethods: [],
        insuranceTypeList: [],
        provisionTypeList: [],
        prescriptionSubTypeList: [],
        medicalDeviceUsageLocationList: [],
        yesNoList: [
          { id: true, name: this.$t('Yes') },
          { id: false, name: this.$t('No') }
        ]
      }
    },
    computed: {
      tooltips() {
        return {
          protocolNo: this.$t('Tooltip.ProtocolNo'),
          trackingNo: this.$t('Tooltip.TrackingNo'),
          prescriptionType: this.$t('Tooltip.PrescriptionType'),
          diagnoses: this.$t('Tooltip.Diagnoses'),
          insuranceType: this.$t('Tooltip.InsuranceType'),
          provisionType: this.$t('Tooltip.ProvisionType'),
          prescriptionSubType: this.$t('Tooltip.PrescriptionSubType'),
          nonDrugsProduct: this.$t('Tooltip.NonDrugsProduct'),
          medicalDevice: this.$t('Tooltip.MedicalDevice'),
          dose1: this.$t('Tooltip.Dose1'),
          dose2: this.$t('Tooltip.Dose2'),
          period: this.$t('Tooltip.Period'),
          box: this.$t('Tooltip.Box'),
          count: this.$t('Tooltip.Count'),
          drugUsageMethod: this.$t('Tooltip.DrugUsageMethod'),
          medicalDeviceUsageLocation: this.$t('Tooltip.MedicalDeviceUsageLocation'),
          comments: this.$t('Tooltip.Comments')
        }
      }
    },
    watch: {
      'model.prescriptionType': function () {
        this.getUsageMethods();
      },
      'model.staffID': function (val) {
        if (!val) {
          this.validateForVSelect();
        } else {
          let staff = this.staffList.find(s => s.id == val);
          if (staff) this.model.drName = staff.name;
        }
      },
      selectedIcdCodes: function (val) {
        this.model.icdCodes = val || [];
      }
    },
    methods: {
      getCustomer() {
        prescriptionService.getCustomer(this.model.customerID)
          .then(data => {
            if (data) {
              this.customer = data;
              if (data.dateOfBirth) {
                this.customer.dateOfBirth = data.dateOfBirth.split('T')[0];
              }
            }
          });
      },
      getStaffList() {
        prescriptionService.getStaffList()
          .then(data => {
            this.staffList = data;
          });
      },
      getPrescriptionTypes() {
        const $this = this;
        prescriptionService.getPrescriptionTypes()
          .then(data => {
            $this.prescriptionTypes = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
          });
      },
      getPeriods() {
        const $this = this;
        prescriptionService.getPeriods()
          .then(data => {
            $this.periodList = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
          });
      },
      getUsageMethods() {
        const $this = this;
        prescriptionService.getDrugUsageMethods(this.model.prescriptionType)
          .then(data => {
            let list = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
            if ($this.model.prescriptionType == 1)
              $this.drugUsageMethods = list;
            else
              $this.sutUsageMethods = list;
          });
      },
      getDeviceUsageLocations() {
        const $this = this;
        prescriptionService.getMedicalDeviceUsageLocations()
          .then(data => {
            $this.medicalDeviceUsageLocationList = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
          });
      },
      getInsuranceTypes() {
        const $this = this;
        prescriptionService.getInsuranceTypes()
          .then(data => {
            $this.insuranceTypeList = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
          });
      },
      getProvisionTypes() {
        const $this = this;
        prescriptionService.getProvisionTypes()
          .then(data => {
            $this.provisionTypeList = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
          });
      },
      getPrescriptionSubTypes() {
        const $this = this;
        prescriptionService.getPrescriptionSubTypes()
          .then(data => {
            $this.prescriptionSubTypeList = data.map(v => {
              v.name = $this.$t(v.name);
              return v;
            });
          });
      },
      fetchDrugs(search) {
        const drugIds = this.model.prescriptionDetails
          .map(d => d.skrsDrugId)
          .filter(id => id != null);

        prescriptionService.searchDrugs({ keyword: search, UsedIdList: drugIds })
          .then(data => {
            this.drugList = data;
          });
      },
      fetchSuts(search) {
        const sutIds = this.model.prescriptionDetails
          .map(d => d.skrsSutId)
          .filter(id => id != null);

        prescriptionService.searchSuts({ keyword: search, UsedIdList: sutIds })
          .then(data => {
            this.sutList = data;
          });
      },
      addDetailRow() {
        this.model.prescriptionDetails.push({
          id: '',
          nonDrugsProduct: false,
          quantity: null,
          period: null,
          dose1: null,
          dose2: null,
          drugUsageMethod: null,
          explanation: null,
          skrsDrugId: null,
          skrsSutId: null,
          drug: '',
          sutUsageLocation: null,
          sutUsageMethod: null
        });
      },
      removeDetailRow(detail) {
        this.model.prescriptionDetails.splice(this.model.prescriptionDetails.indexOf(detail), 1);
      },
      fetchIcdCodes(search) {
        if (search && search.length >= 2) {
          customerDiagnoseService.getIcdList(search)
            .then(data => {
              this.icdList = data;
            });
        }
      },
      setIcdCodesFromDiagnosisCodes(diagnosisCodes) {
        const codes = [...new Set(diagnosisCodes.split(/[,;]/).map(s => s.trim()).filter(Boolean))];

        Promise.all(codes.map(code => customerDiagnoseService.getIcdList(encodeURIComponent(code))
          .then(data => (data || []).find(s => s.name.startsWith(code + ' - ')))
          .catch(() => null)))
          .then(icds => {
            const found = icds.filter(Boolean);
            if (found.length && !this.selectedIcdCodes.length) {
              this.icdList = found;
              this.selectedIcdCodes = found.map(s => s.id);
            }
          });
      },
      validateForVSelect() {
        let isValid = true;
        if (!this.model.staffID) {
          this.validationErrors.StaffID = this.$t('ValidationMessage.CannotBeEmpty');
          isValid = false;
        } else {
          this.validationErrors.StaffID = '';
        }
        return isValid;
      },
      submitPrescription() {
        if (!this.validateForVSelect()) return;

        this.model.showNationalNumberOnPdf = true;
        this.model.showDateOfBirthOnPdf = true;
        this.model.showGenderOnPdf = true;

        this.isSubmitting = true;

        prescriptionService.submitPrescription(this.model)
          .then(result => {
            this.isSubmitting = false;
            if (result?.status === 'Success') {
              window.open(result.data, 'İlaç Reçetesi', '');
              this.$toastr.success(this.$t('Success'));
              let currentModalId = this.$store.getters['Modal/currentModalId'];
              if (currentModalId) {
                this.$bvModal.hide(currentModalId);
              } else {
                this.$router.go(-1);
              }
            } else {
              this.$toastr.error(result?.message || this.$t('Error'));
            }
          })
          .catch(error => {
            this.isSubmitting = false;
            this.$toastr.error(error?.response?.data?.message || this.$t('Error'));
          });
      }
    },
    mounted() {
      this.model.customerID = this.$route.params.customerId || this.customerId;

      if (this.sysTakipNo) {
        this.model.sysTakipNo = this.sysTakipNo;
        if (this.prescriptionCode)
          this.setIcdCodesFromDiagnosisCodes(this.prescriptionCode);
        if (this.staffId)
          this.model.staffID = this.staffId;
        if (this.hospitalReferenceNo)
          this.model.hospitalReferenceNo = this.hospitalReferenceNo;
      }

      this.addDetailRow();
      this.getCustomer();
      this.getStaffList();
      this.getPrescriptionTypes();
      this.getPeriods();
      this.getUsageMethods();
      this.getDeviceUsageLocations();
      this.getInsuranceTypes();
      this.getProvisionTypes();
      this.getPrescriptionSubTypes();
    }
  }
</script>

<style scoped>
  .drug-row {
    background-color: #f8f9fa;
  }
  .drug-row:hover {
    background-color: #f0f2f5;
  }
  .drug-row .form-group > label,
  .drug-row .form-group > legend {
    min-height: 2.4em;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.25rem;
    line-height: 1.2;
  }
  .info-tip {
    color: #17a2b8;
    font-size: 0.8em;
    cursor: help;
    margin-left: 4px;
    opacity: 0.7;
  }
  .info-tip:hover {
    opacity: 1;
  }
</style>
